export const TIME_TO_PRAY = /dev|preprod|staging/.test(CONF_KEYS.ENV) ? 1500 : 15000

export enum PRAY_OBJECT_TYPE {
  INTENTION = 'intention',
  COMMUNITY = 'community',
  USER = 'user',
}
